// extracted by mini-css-extract-plugin
export var movingGradient = "_2f-3";
export var skeleton = "_2f-0";
export var skeletonText = "_2f-1";
export var skeletonTextAnimation = "_2f-2";